document.addEventListener('DOMContentLoaded', function() {
	
		console.log('DOMContentLoaded');

    // Find all accordion sections
    const accordionSections = document.querySelectorAll('.accordion-wrap');
    
    accordionSections.forEach(section => {
        // Find all toggle buttons within this section
        const toggleButtons = section.querySelectorAll('.accordion-toggle');
        
        toggleButtons.forEach(button => {
            button.addEventListener('click', function() {
                const target = document.querySelector(this.dataset.target);
                const parent = document.querySelector(this.dataset.parent);
                
                // Close all other accordion items in this section
                const siblings = parent.querySelectorAll('.accordion-text');
                siblings.forEach(sibling => {
                    if (sibling !== target) {
                        sibling.style.maxHeight = null;
                        sibling.classList.remove('active');
                        
                        // Remove active state from other buttons
                        const siblingButton = sibling.previousElementSibling;
                        siblingButton.classList.remove('active');
                        siblingButton.setAttribute('aria-expanded', 'false');
                    }
                });
                
                // Toggle current accordion item
                if (!target.style.maxHeight) {
                    target.style.maxHeight = target.scrollHeight + 'px';
                    target.classList.add('active');
                    this.classList.add('active');
                    this.setAttribute('aria-expanded', 'true');
                } else {
                    target.style.maxHeight = null;
                    target.classList.remove('active');
                    this.classList.remove('active');
                    this.setAttribute('aria-expanded', 'false');
                }
            });
            
            // Set initial ARIA attributes
            button.setAttribute('aria-expanded', 'false');
        });
    });
});
